// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2KNw8","large":"styles_large__EFz7d"};